import React, { useState } from 'react';
import Field from '../Field';
import DateTimePicker from '../DateTimePicker';

export default props => {
  if (!props.onChange && !props.valueField?.onChange) {
    return (
      <Field {...props}>
        <DateTimePicker />
      </Field>
    );
  }

  const onChange = props.onChange || props.valueField?.onChange;
  const [validValue, setValidValue] = useState(props.valueField?.value);

  //это блокирует смену даты на невалидную с помощью стрелок смены месяца/года в календаре
  const handleChange = date => {
    if (!date || !props.disabledDate || !props.disabledDate(date)) {
      setValidValue(date);
    }

    onChange(date);
  };

  const handleBlur = (...args) => {
    if (props.disabledDate && props.disabledDate(props.valueField?.value)) {
      onChange(validValue);
    }

    if (props.valueField?.onBlur) {
      props.valueField?.onBlur(...args);
    }
  };

  return (
    <Field {...props} onChange={handleChange} onBlur={handleBlur}>
      <DateTimePicker />
    </Field>
  );
};
